// Tant que `actif` est vrai (du travail pas encore enregistré), le navigateur
// demande confirmation avant de recharger ou de fermer l'onglet. Le message
// est celui du navigateur : il ne se personnalise pas.
import { useEffect } from "react";

export default function useAlerteDepart(actif) {
	useEffect(() => {
		if (!actif) return undefined;
		const avertir = (e) => {
			e.preventDefault();
			// Chrome, Edge et les anciens Safari attendent encore returnValue.
			e.returnValue = "";
		};
		window.addEventListener("beforeunload", avertir);
		return () => window.removeEventListener("beforeunload", avertir);
	}, [actif]);
}
